import { ChangeDetectorRef, Component, Input, output, inject, input } from '@angular/core';
import type { UntypedFormControl } from '@angular/forms';
import { ReactiveFormsModule } from '@angular/forms';

import type { User, UserBase, UserWithRole } from '@core/account-types';
import { TranslatePipe } from '@core/i18n-legacy';
import {
  IconButtonComponent,
  DividerComponent,
  TruncateComponent,
  HeadingComponent,
  AvatarComponent,
  CheckboxComponent,
} from '@core/user-interface-legacy';

import type { RoleWithAdmins } from '../../../types';

@Component({
  selector: 'rt-visibility-admin-item',
  templateUrl: 'visibility-admin-item.component.html',
  styleUrls: ['./visibility-admin-item.component.less'],
  imports: [
    CheckboxComponent,
    ReactiveFormsModule,
    AvatarComponent,
    HeadingComponent,
    TruncateComponent,
    DividerComponent,
    IconButtonComponent,
    TranslatePipe,
  ],
})
export class VisibilityAdminItemComponent {
  private readonly cdRef = inject(ChangeDetectorRef);

  public readonly admin = input<UserWithRole>(undefined!);
  public readonly currentAdmin = input<UserBase>(undefined!);
  public readonly hasDivider = input<boolean>(false);
  public readonly hasNoBorderBottom = input<boolean>(false);
  public readonly hasPadding = input<boolean>(false);
  public readonly hasCheckboxOffset = input<boolean>(false);
  public readonly kind = input<'admin' | 'role' | 'simple-admin' | 'no-access'>('admin');
  public readonly form = input<UntypedFormControl | null>(undefined!);
  public readonly checked = input<false | number>(undefined!);
  public readonly roleAssignmentsGroup = input<{
    [roleId: string]: number | false;
  } | null>(null);
  public readonly groupUsersByAccess = input(false);
  @Input() public roleWithAdmins: RoleWithAdmins | null = null;

  public checkboxClick = output<void>();
  public toggleAssignment = output<User | RoleWithAdmins>();

  public expanded: boolean = false;

  public toggleList($event: MouseEvent): void {
    $event.stopPropagation();
    this.expanded = !this.expanded;
    this.cdRef.detectChanges();
  }

  public trackById<T extends { id: number }>(index: number, { id }: T): number {
    return id;
  }
}
